import logoXM from "../../../../images/xm-logo.png";
import logoIcipc from "../../../../images/icipc.png";

function BackingSection() {
  return (
    <section className="bg-[#f8fafc] text-center">
      <div className="max-w-[900px] mx-auto py-96 px-40">
        <h2 className="text-40 font-extrabold text-[#1E3A8A] mb-20 leading-[1.2]">
          Tecnología respaldada por experiencia
        </h2>
        <p className="text-20 text-[#555] leading-[1.8] max-w-[680px] mx-auto mb-56">
          EcoRep cuenta con el respaldo tecnológico de XM y utiliza estándares avanzados de seguridad y procesamiento de información para garantizar la confiabilidad de cada registro.
        </p>
        <div className="flex justify-center items-center gap-64 flex-wrap">
          <img src={logoXM} alt="XM" className="max-h-56 object-contain opacity-80 transition-opacity duration-200 hover:opacity-100" />
          <img src={logoIcipc} alt="Icipc" className="max-h-96 object-contain opacity-80 transition-opacity duration-200 hover:opacity-100" />
        </div>
      </div>
    </section>
  );
}

export default BackingSection;
